/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */


const theme = {
  appearances: {
    background: {
      description: 'Background colour of box. No background color if not specified',
      type: 'variant',
      values: [
        'lightest',         'lighter',
        'light',            'dark',
        'darker',           'darkest',
        'critical',         'danger',
        'warning',          'positive',
        'brand',            'white',
        'black',            'featurePrimary',
        'featureSecondary', 'featureNeutral',
        'featureBrand'
      ]
    }
  },
  rules: [
    {
      if: { background: 'lightest' },
      tokens: { backgroundColor: '#fefefc', borderColor: '#fefefc' }
    },
    {
      if: { background: 'lighter' },
      tokens: { backgroundColor: '#fdfcf6', borderColor: '#fdfcf6' }
    },
    {
      if: { background: 'light' },
      tokens: { backgroundColor: '#fcf8ee', borderColor: '#fcf8ee' }
    },
    {
      if: { background: 'dark' },
      tokens: { backgroundColor: '#6a7080', borderColor: '#6a7080' }
    },
    {
      if: { background: 'darker' },
      tokens: { backgroundColor: '#394056', borderColor: '#394056' }
    },
    {
      if: { background: 'darkest' },
      tokens: { backgroundColor: '#2b3145', borderColor: '#2b3145' }
    },
    {
      if: { background: 'critical' },
      tokens: { backgroundColor: '#bf1722', borderColor: '#bf1722' }
    },
    {
      if: { background: 'danger' },
      tokens: { backgroundColor: '#f9e8e9', borderColor: '#f9e8e9' }
    },
    {
      if: { background: 'warning' },
      tokens: { backgroundColor: '#fcf8ee', borderColor: '#fcf8ee' }
    },
    {
      if: { background: 'positive' },
      tokens: { backgroundColor: '#eaf3f1', borderColor: '#eaf3f1' }
    },
    {
      if: { background: 'brand' },
      tokens: { backgroundColor: '#394056', borderColor: '#394056' }
    },
    {
      if: { background: 'white' },
      tokens: { backgroundColor: '#ffffff', borderColor: '#ffffff' }
    },
    {
      if: { background: 'black' },
      tokens: { backgroundColor: '#2b3145', borderColor: '#2b3145' }
    },
    {
      if: { background: 'featurePrimary' },
      tokens: { backgroundColor: '#f6b5a0', borderColor: '#f6b5a0' }
    },
    {
      if: { background: 'featureSecondary' },
      tokens: { backgroundColor: '#f9cebf', borderColor: '#f9cebf' }
    },
    {
      if: { background: 'featureNeutral' },
      tokens: { backgroundColor: '#fce6df', borderColor: '#fce6df' }
    },
    {
      if: { background: 'featureBrand' },
      tokens: { backgroundColor: '#f39d80', borderColor: '#f39d80' }
    }
  ],
  tokens: {
    backgroundColor: null,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: null,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderWidth: 0,
    gradient: null
  }
}
export default theme
